<accordion *ngIf="screeningResult || (triageData && isFirstSession)" (onToggle)="onToggleAccordion($event)" [isOpen]="true" [title]="'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.TITLE' | translate" icon="clipboard-list" [tag]="'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.TAG' | translate">
	<div *ngIf="screeningResult" class="zk-flex zk-flex-row zk-gap-1">
		<p class="text" freud-typography fontType="h5RegularAuto">
			{{ screeningResult }}
		</p>
	</div>
	<div *ngIf="triageData && isFirstSession" class="zk-flex zk-flex-col zk-gap-1">
		<div class="zk-flex zk-flex-col zk-gap-1">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.REASON' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ formatTriageReasons()  }}
			</p>
		</div>
		<div class="zk-flex zk-flex-col zk-gap-1">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.HAD_THERAPY' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ triageData.alreadyHadTherapy 
						? ('APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.ANSWERS.YES' | translate)
						: ('APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.ANSWERS.NO' | translate)
				}}
			</p>
		</div>
		<div class="zk-flex zk-flex-col zk-gap-1">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.HAD_MEDICATION' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ triageData.hasTakenMedication 
					? ('APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.ANSWERS.YES' | translate)
					: ('APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.ANSWERS.NO' | translate)
				}}
			</p>
		</div>
		<div *ngIf="triageData.medicationName" class="zk-flex zk-flex-col zk-gap-1">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.WHICH_MEDICATION' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ triageData.medicationName ?? 'N/A' }}
			</p>
		</div>
		<div *ngIf="triageData.pointOfLife" class="zk-flex zk-flex-col zk-gap-1">
			<p freud-typography fontType="h5SemiboldAuto">
				{{ 'APPOINTMENTS.DETAILS.BODY.TRIAGE_DATA.CHALLENGES' | translate }} 
			</p>
			<p class="text" freud-typography fontType="h5RegularAuto">
				{{ triageData.pointOfLife }}
			</p>
		</div>
	</div>
</accordion>